(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-team-context"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-team-context')) {
    customElements.define('custom-team-context', class extends HTMLElement {
      connectedCallback() {
        const sync = () => {
          if (!this.isConnected) return;
          document.querySelectorAll('[data-custom-team-context]').forEach(input => {
            input.value = this.dataset.context || '';
          });
        };
        queueMicrotask(sync);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', sync, {once: true});
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
